'use client'

export * from './use-parse-search-params-next.ts'
/**
 * Next.js nuqs adapter.
 *
 * This is the explicit Next subpath for query-string state. Next apps should
 * import from here instead of `@repo/sdk` or `@repo/sdk/qs` root, which are
 * deprecated transitional aliases.
 */
export * from 'nuqs'
export * from 'nuqs/adapters/next/app'
export * from 'nuqs/adapters/testing'
